<template>
  <div id="search-policies">
    <div
      class="pt-4 pl-4 pr-4 text-sm-center"
      >
      <h4 class="modal_header">   <svg @click="closeModal" class="pointer" xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 21 20" fill="none" style="margin-left: -20px; margin-right: 10px;">
  <path d="M11.9965 18.3898L11.0055 19.3747C10.5859 19.7918 9.90743 19.7918 9.4923 19.3747L0.814697 10.7542C0.395101 10.3372 0.395101 9.66281 0.814697 9.2502L9.4923 0.625286C9.9119 0.208238 10.5904 0.208238 11.0055 0.625286L11.9965 1.61023C12.4205 2.03172 12.4116 2.7194 11.9786 3.13201L6.59977 8.22533H19.4287C20.0224 8.22533 20.5 8.70005 20.5 9.29013V10.7099C20.5 11.2999 20.0224 11.7747 19.4287 11.7747H6.59977L11.9786 16.868C12.4161 17.2806 12.425 17.9683 11.9965 18.3898Z" fill="#191737"/>
  </svg>
        {{ modalOptions[kindEndorsement].title }}
      </h4>
      <p class="subheading ">
        {{ modalOptions[kindEndorsement].subtitle}}
      </p>
      <v-text-field
        v-model="term"
        outline
        prepend-inner-icon="search"
        @keyup.enter="getPolicy(term)"
        label="Pesquise número da proposta/apólice."
        class="search"
        
        @input="onChangeSearchTerm(self, term)"
        />
    </div>
    <div class="pa-4 listing">
          <div>
            <v-data-table
          class="datatable search-policies__datatable"
          hide-actions
          :headers="headers"
          :items="pagedItems" 
        >
          <template v-slot:items="{ item, item: { id_apolice, tomador, segurado } }">
            <tr class="pointer" @click="onSelectPolicy(item)">
              <td class="modal_style">{{ id_apolice }}</td>
              <td class="modal_style">{{ tomador.nome }}</td>
              <td class="modal_style">{{ segurado.nome }}</td>
              <td><svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.882812 12.2768L0.882813 0.814241C0.882813 0.194172 1.63617 -0.11876 2.0708 0.321663L7.76732 6.05296C8.03968 6.32532 8.03968 6.75995 7.76732 7.03232L2.0708 12.7636C1.63617 13.2098 0.882812 12.8969 0.882812 12.2768Z" fill="#282498"/>
</svg></td>
            </tr>
          </template>
        </v-data-table>
       <div class="div_notice"><p>Para apólices mais antigas utilize a barra de pesquisa ou navegue entre as páginas.</p></div>
       <div class="div_pagination" style="display: flex; align-items: center;">
  <div>
  <p style="white-space: nowrap; margin-right: 10px;">
    Apólices por página: &nbsp;
    <label style="position: relative;">
  <select v-model="itemsPerPage" @change="updateItemsPerPage" style="padding-right: 20px;">
    <option disabled value=""></option>
    <option>10</option>
    <option>20</option>
    <option>30</option>
    <option>40</option>
    <option>50</option>
  </select>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 8 6" fill="none" style="position: absolute; right: 8; top: 50%; transform: translateY(-50%);">
    <path d="M3.43496 5.25595C3.74733 5.58135 4.25462 5.58135 4.56699 5.25595L7.76565 1.92392C7.99556 1.68443 8.06303 1.3278 7.93808 1.01542C7.81313 0.703047 7.52325 0.5 7.19839 0.5L0.801058 0.5C0.478692 0.5 0.186314 0.703046 0.061366 1.01542C-0.0635821 1.3278 0.006389 1.68443 0.233794 1.92392L3.43246 5.25595L3.43496 5.25595Z" fill="black"/>
  </svg>
  
</label>
    &nbsp;&nbsp;&nbsp;&nbsp;{{ currentPageRange }}
  </p>
  <div class="borda"></div>
</div>
  <div class="pagination" style="display: flex; align-items: center;">
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="12" viewBox="0 0 39 12" fill="none">
  <!-- Hitbox e caminho para o clique anterior -->
  <a @click="goToPage(currentPage - 1)" style="cursor: pointer;">
    <rect x="0" y="0" width="25" height="15" fill="transparent"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z" fill="#191737"/>
  </a>
  
  <!-- Hitbox e caminho para o clique seguinte -->
  <a @click="goToPage(currentPage + 1)" style="cursor: pointer;">
    <rect x="21" y="0" width="25" height="15" fill="transparent"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.6016 1.4L33.0016 0L39.0016 6L33.0016 12L31.6016 10.6L36.2016 6L31.6016 1.4Z" fill="#191737"/>
  </a>
</svg>


</div>
</div>

      </div>
    </div>
  </div>
</template>

<script type="js">
import _ from "lodash";
import { KIND_ENDORSEMENTS } from '@/libs/endorsement'
import ViewMixin from "@/mixins/ViewMixin";
const makeHeader = (text, value) => ({
  class: "table-header",
  align: "left",
  text, value
});

const tableHeaders = [
  makeHeader("Nº da apólice", "id_apolice"),
  makeHeader("Tomador", "tomador.nome"),
  makeHeader("Segurado", "segurado.nome")
];

export default {
  name: "PesquisarApolice",
  mixins: [ViewMixin],
  props: {
    items: { type: Array },
    kindEndorsement: {
      type: String,
      default: false
    }
  },
  data() {
    return {
      showModal: true,
      selectedValue: "",
      currentPage: 1, 
      itemsPerPage: 10,
      paginationText: "",
      self: this,
      term: "",
      headers: tableHeaders,
      modalOptions: {
        [KIND_ENDORSEMENTS.CANCELAMENTO]: {
          title: 'Endosso de Cancelamento',
          subtitle: 'Selecione a apólice que deseja realizar o cancelamento.'
        },
        [KIND_ENDORSEMENTS.ALTERACAO]: {
          title: 'Endosso de Alteração de Vigência e/ou IS',
          subtitle: 'Selecione a apólice que deseja realizar a alteração.'
        }
      }
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    pagedItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.items.slice(startIndex, endIndex);
    },

    currentPageRange() {
      const value = (this.currentPage - 1) * this.itemsPerPage + 1;
      const start = value.toString().padStart(2, '0')
      let end = this.currentPage * this.itemsPerPage;
      end = end > this.items.length ? this.items.length : end;
      return `${start}-${end} de  ${this.items.length}`;
    },


  },

  methods: {
  onChangeSearchTerm: _.debounce(function(vm, term) {
    this.goToPage(1)
    vm.$emit('search', term)
  }, 300),
  onSelectPolicy(policy) {
    this.$emit('selected-policy', policy);
  },

  handleInput(value) {
      this.itemsPerPage = value
  },
  updateItemsPerPage() {
      this.goToPage(1)
      this.itemsPerPage = parseInt(this.itemsPerPage, 10);
    },
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
      }
    },
    closeModal() {
    this.$emit('close'); 
  },
  async getPolicy(apoliceId){


    try {
    this.showLoadingAskWait();
    const policy = await this.$store.dispatch("GET_POLICY", {
          apoliceId
        });
    this.items = [policy]
    }finally{
      this.hideLoadingAskWait();
    }


    
  }
    
}
};
</script>



<style lang="scss">


.borda {
  background: #000;
  width: 33px;
  height: 2px;
  margin-left: 140px;
  margin-top: -18px;
}

.modal_header {
  color: #191737;
  text-align: center;
  font-family: Avenir;
  font-size: 28px;
  font-weight: bolder;
  line-height: 28px; /* 127.273% */
  margin-bottom: 4px;
  
  }

.v-text-field.search {
  .v-input__slot {
    border: 1px solid #E9E9E9 !important;
    color: #636363;
  }
  .v-label {
  color: #636363;
  font-family: Avenir;
}
}

.test {
  color: #636363;
  font-family: Avenir;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.pagination {
  display: flex;
  align-items: center;
  margin-top: -3px; 
  gap: 1px;
  margin-left: 5px;
}



.disabled {
  opacity: 0.5; 
  pointer-events: none; 
}

.listing {
  flex-grow: 1;
  background-color: #F7F7FB;
  overflow: auto;
}
.search-policies__datatable {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  
}



.div_notice {
  width: 265px;
  margin-top: 20px;
  padding-left: 2px;
  display: block; 
  margin-bottom: -10px;

  p{
    color: #191737;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  }
}

.div_pagination {
  width: 280px;
  margin-left: 320px;
  margin-top: -50px;

}



::-webkit-scrollbar {
  width: 0.325rem;
  height: 2.0625rem;
  flex-shrink: 0; 
}

::-webkit-scrollbar-thumb {
  background-color: #191737; 
}

::-webkit-scrollbar-thumb:hover {
  background-color: #191737; 
}


@-moz-document url-prefix() {
  scrollbar-width: thin; 
}
</style>



// WEBPACK FOOTER //
// ./src/components/PesquisarApolice.vue